import Axios from 'axios'
import React, { Component } from 'react'
import ReadAxios from '../axiosComponent/read'

export default class vehicleTypeRenderer extends Component {

    state = {
        cityNames: []
    }

    componentDidMount() {
        ReadAxios({
            url: `vehicleMaster/${this.props.data.vehicle_id}`,
        }).then((res) => {
            if (res.status === 200) {
                let name = res.data.resultSet[0] ? res.data.resultSet[0]['vehicleType'] : ""
                this.setState({
                    cityNames: name
                })
            }
        })
    }


    render() {
        return (
            <div>
                {/* {this.state.cityNames.length > 0 ? 
                this.state.cityNames.map((o,i)=>(
                    <>{o}</>
                )):''} */}
                {this.state.cityNames}
            </div>
        )
    }
}
